<template>
  <div>
    <h1 class="title">
      En este modulo podrá agregarle los vendedores a las ventas de un cliente
    </h1>
    <div class="columns">
      <div class="column is-2">
        <button class="button is-link" @click="downexemplereg">
          Descargar Ejemplo
        </button>
      </div>
      <div class="column">
        <div class="field">
          <div class="file is-light">
            <label class="file-label" style="margin-left: 10px">
              <input
                class="file-input"
                type="file"
                accept=".xls, .xlsx"
                @change="onFileChange"
                name="resume"
              />
              <span class="file-cta">
                <span class="file-icon">
                  <i class="material-icons">cloud_upload</i>
                </span>
                <span class="file-label">Cargar desde Excel</span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <button class="button is-link" @click="addNit">
          Agregar Tercero a Listado Fra Elect
        </button>
      </div>
    </div>
    <progress
      v-show="avaceupload > 0"
      class="progress is-info is-small"
      :value="avaceupload"
      max="100"
    ></progress>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      avaceupload: 0,
      error: null,
      query: {
        url: "",
      },
    };
  },
  methods: {
    async addNit() {
      try {
        console.log("estoy funcionando");
        const result = await apiServices.get(`/addnitelect`);
        if (result.data) {
          console.log(result.data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    closenotification() {
      this.error = null;
    },
    onFileChange(e) {
      const _this = this;
      let task;
      const files = e.target.files;
      if (files.length) {
        const file = files[0];
        task = _this.$fire.refexcel(file);
        _this.avaceupload = 10;
        task.on(
          "state_changed",
          (snapshot) => {
            const porcentaje =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            if (porcentaje > 10) {
              _this.avaceupload = porcentaje;
            }
          },
          (err) => {
            console.log("error subiendo el archivo", err);
          },
          async () => {
            try {
              const url = await task.snapshot.ref.getDownloadURL();
              _this.avaceupload = 0;
              _this.query.url = url;
              const result = await apiServices.post(
                `/uploadsellers`,
                this.query
              );
              console.log(result);
            } catch (err) {
              console.log("ocurrio un error", err);
            }
          }
        );
      }
    },
    async downexemplereg() {
      try {
        let result;
        result = await apiServices.post(
          `/downexempleaddsellers`,
          { np: "np" },
          { responseType: "blob" }
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(`download`, `Ejemplo.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/addsellers/Addsellers.vue